import "./footer.css";

const Footer = () => {
  return (
    <div className="footer">
      <div className="footer-copyright">
        <h3>©2022 Sixvago</h3>
      </div>
      <div className="footer-icons">
        <i className="fa-brands fa-facebook"></i>
        <i className="fa-brands fa-linkedin-in"></i>
        <i className="fa-brands fa-twitter"></i>
        <i className="fa-brands fa-instagram"></i>
      </div>
    </div>
  );
};

export default Footer;
